module.exports = __webpack_public_path__ + "i18n/it.c32875e57273a6bf122df3de397912ec.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=i18n/[name].[hash].[ext]!./i18n/it.json
// module id = 1308
// module chunks = 59